// extracted by mini-css-extract-plugin
export var navigation = "Header-module--navigation--rLyZT";
export var mainNav = "Header-module--mainNav--Bcjyg";
export var mainNavMobile = "Header-module--mainNavMobile--vhCqh";
export var logoContainer = "Header-module--logoContainer--T80Ei";
export var hamContainer = "Header-module--hamContainer--SkQN8";